import type { DashboardSnapshot } from "@/domain/model/Dashboard";
import type { DashboardService } from "@/domain/port/DashboardService";

export class GetDashboardSnapshot {
  constructor(private readonly service: DashboardService) {}

  execute(signal?: AbortSignal): Promise<DashboardSnapshot> {
    return this.service.getDashboardSnapshot(signal);
  }}
